export const SELLER_ORDER_STATUS = {
    SENT: { label: "Aguardando aprovação", color: "blue" },
    APPROVED: { label: "Aprovada", color: "green" },
    REJECTED: { label: "Rejeitada", color: "red" },
    CANCELED: { label: "Cancelada", color: "" },
};

export const CANCELABLE_STATUSES = ["DRAFT", "SENT"];

export const FINAL_STATUSES = ["APPROVED", "REJECTED", "CANCELED", "EMPTY"];

export const ALL_SELLER_ORDER_STATUS = {
    ...SELLER_ORDER_STATUS,
    DRAFT: { label: "Em digitação", color: "orange" },
    EMPTY: { label: "Sem produtos", color: "" },
};

export const PURCHASE_REGIMES = {
    QUOTATION: { label: "Cotação", color: "blue" },
    DIRECT: { label: "Pedido direto", color: "gold" },
};

export const LINE_ORIGINS = {
    PURCHASE_SOURCE: { label: "Mix do cliente", color: "" },
    SCAN: { label: "Leitura de código", color: "purple" },
    SEARCH: { label: "Busca", color: "cyan" },
};

export const LINE_STATUS = {
    PENDING: { label: "Pendente", color: "orange" },
    OFFERED: { label: "Ofertado", color: "green" },
    SKIPPED: { label: "Não ofertado", color: "" },
    SHORTAGE: { label: "Em falta", color: "volcano" },
};
